<div fxLayout="row" fxLayoutAlign="start start" fxFlex.gt-sm="100" class="d-block">

    <fieldset>
        <legend>Gestión</legend>
        <mat-form-field class="mr-20">
            <mat-label>Coordinador de la empresa</mat-label>
            <mat-select class="full-width-multi-select" [formControl]="filterService.TaskCoordinador"
                (ngModelChange)="SetFilterValues('Coordinador', $event)">
                <mat-option *ngFor="let Cordinadr of filterService.CoordinadorList$" [value]="Cordinadr.viewValue">
                    {{Cordinadr.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="mr-20">
            <mat-label>Gestor de la empresa</mat-label>
            <mat-select class="full-width-multi-select" [formControl]="filterService.TaskGestor"
                (ngModelChange)="SetFilterValues('Gestor', $event)">
                <mat-option *ngFor="let Gestor of filterService.GestorList$" [value]="Gestor.administrativa">
                    {{Gestor.nombre}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </fieldset>

    <fieldset>
        <legend>Baja</legend>
        <app-leave-type-filter [LeaveTypeControl]="filterService.LeaveType" (LeaveTypeSelected)="SetLeaveType($event)">
        </app-leave-type-filter>
    </fieldset>

    <fieldset>
        <legend>FPA</legend>
        <div class="d-flex">
            <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.Common"
                [PeriodFrom]="filterService.FPAFrom" [PeriodTo]="filterService.FPATo"
                (FromDateChanged)="SetFilterValues(ControlNames.FPAFrom, $event)"
                (ToDateChanged)="SetFilterValues(ControlNames.FPATo, $event)"></app-date-period-filter>
        </div>
    </fieldset>

    <fieldset>
        <legend>Días de baja</legend>
        <div class="d-flex">
            <div>
                <mat-form-field class="half-width-form-field dias-field-left">
                    <mat-label>Desde</mat-label>
                    <input type="number" matInput autocomplete="off" min="0" [formControl]="filterService.DiasFrom"
                        (change)="SetFilterValues(ControlNames.DiasFrom, $event)">
                </mat-form-field>

                <mat-form-field class="half-width-form-field">
                    <mat-label>Hasta</mat-label>
                    <input type="number" matInput autocomplete="off" min="0" [formControl]="filterService.DiasTo"
                        (change)="SetFilterValues(ControlNames.DiasTo, $event)">
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset>
        <legend>Provincia / población</legend>
        <div class="d-flex">
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Provincia</mat-label>
                <mat-select 
                name="provinciaSelect"
                [(ngModel)]="selectionService.taskSelectionModal.Provincia"  [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onProvinciaChange($event)">
                
                <div class="buscador-container">
                    <input class="buscador-input" placeholder="Buscar provincia..." 
                        (input)="filtrarProvincias($event)" 
                        (keydown)="$event.stopPropagation()">
                </div>
                @for (prov of filteredProvinceList; track prov.value) {
                    <mat-option [value]="prov.value">{{ prov.viewValue }}</mat-option>
                }
                </mat-select>
          </mat-form-field>
                <mat-form-field appearance="outline">
                <mat-label>Población</mat-label>
                <mat-select 
                    name="poblacionSelect"
                    [(ngModel)]="selectionService.taskSelectionModal.Poblacion"  [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPoblacionChange($event)">
                    
                    <div class="buscador-container">
                    <input class="buscador-input" placeholder="Buscar población..." 
                            (input)="filtrarPoblaciones($event)" 
                            (keydown)="$event.stopPropagation()">
                    </div>
                    @for (pob of filteredPoblacionList; track pob) {
                    <mat-option [value]="pob">{{ pob }}</mat-option>
                    }
                </mat-select>
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset class="taskType-panel">
        <legend>Tipos de Tareas</legend>
        <app-task-type-tree-view (TaskTypeSelect)="setSelectedActivityType($event,true)"
            (TaskTypeDeselect)="setSelectedActivityType($event,false)"></app-task-type-tree-view>
    </fieldset>

</div>